import { Component, ReactNode } from 'react'

import { AccidentProps } from './StatusSlice'

import Select from "../../libs/ui/inputs/Select"

class Incidente extends Component<AccidentProps> {

    constructor (props: any) {
        super(props)

        this.updateAnnoIncidente = this.updateAnnoIncidente.bind(this)
        this.updateRespoIncidente = this.updateRespoIncidente.bind(this)
    }

    render(): ReactNode {
        const numero = this.props.incidente.numero

        const anno_id = 'anno_' + numero
        const resp_id = 'respo_' + numero

        const incidente = (this.props.incidente)
            ? this.props.incidente
            : {anno: undefined, responsabilita: undefined}

        const annoError = (this.props.incidenteError?.error !== undefined && incidente.anno === undefined) ? 'Valore non valido' : undefined
        const respError = (this.props.incidenteError?.error !== undefined && incidente.responsabilita === undefined) ? 'Valore non valido' : undefined

        return (
            <div className='row accident-container'>
                <p className='col-12'>
                    <span className='p-small'>Incidente {numero}</span>
                </p>

                <div className='col-12 col-md-4'>
                    <Select
                        id={anno_id} name={anno_id} key={anno_id}
                        label='Anno' 
                        value={incidente.anno}
                        options={this.props.tipiAnno}
                        callback={this.updateAnnoIncidente}
                        error={annoError}
                    />                    
                </div>

                <div className='col-12 col-md-8'>
                    <Select
                        id={resp_id} name={resp_id} key={resp_id}
                        label='Responsabilità' 
                        value={incidente.responsabilita}
                        options={this.props.tipiResponsabilita}
                        callback={this.updateRespoIncidente}
                        error={respError}
                    />
                </div>
            </div>
        )
    }


    private updateAnnoIncidente (val: string) {
        const incidente = {
            ...this.props.incidente,
            ...{anno: val}
        }

        this.props.updateIncidente(
            incidente
        )
    }

    private updateRespoIncidente (val: string) {
        const incidente = {
            ...this.props.incidente,
            ...{responsabilita: val}
        }

        this.props.updateIncidente(
            incidente
        )
    }
}

export default Incidente